import '../layout/theme';
const $ = window.$;
import '../sections/product';
import Swiper, {Navigation, Zoom, Scrollbar, Keyboard, Lazy} from 'swiper';

function initProductGallery() {
  const swiper = new Swiper('.swiper', {
    keyboard: true,
    preloadImages: false,
    lazy: {
      checkInView: true,
      loadPrevNext: true,
    },
    zoom: {
      toggle: false,
    },
    navigation: {
      nextEl: '.flickity-prev-next-button.next',
      prevEl: '.flickity-prev-next-button.previous',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    modules: [Navigation, Zoom, Scrollbar, Keyboard, Lazy],
  });

  const tiles = document.querySelectorAll('#product-section .tile');
  const gallery = document.querySelector('#product-section .swiper.carousel');
  const closeButton = document.querySelector('.image-gallery .close-button');
  const mobileZoomInButton = document.querySelector('.mobile-zoom-in');

  // Desktop: Tiles Click
  tiles.forEach((tile, index) => {
    tile.addEventListener('click', (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (history) {
        if ((history.state === null) || (!history.state.pdp)) {
          history.pushState({pdp: true}, null);
        }
      }

      showDesktopGallery();
      swiper.slideTo(index, 0, false);
      swiper.update();
    }, false);
  });

  swiper.on('click', (sw, event) => {
    const zoomClickArea = swiper.clickedSlide.querySelector('.zoom-click-area');
    if (zoomClickArea.contains(event.target)) {
      swiper.zoom.toggle(event);
    } else {
      swiper.zoom.toggle();
    }
  });

  const body = document.querySelector('body');

  function showDesktopGallery() {
    gallery.classList.add('is-fullscreen');
    body.classList.add('hide-scrollbars');
  }

  // Get rid of excessive back-link when closing gallery via close button or esc key
  function checkHistory() {
    if (history) {
      if ((history.state !== null) && (history.state.pdp)) {
        history.back();
        return true;
      }
    }
    return false;
  }

  // Desktop: exit fullscreen mode...
  function closeDesktopGallery() {
    gallery.classList.remove('is-fullscreen');
    body.classList.remove('hide-scrollbars');
    swiper.zoom.out();
  }

  // ...on close button click
  closeButton.addEventListener('click', () => {
    if (checkHistory()) return;

    closeDesktopGallery();
  });

  // ... on ESC key
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    if (checkHistory()) return;

    closeDesktopGallery();
  });

  // ...on browser back button
  onpopstate = (event) => {
    if (event.state && event.state.pdp) {
      showDesktopGallery();
      return;
    }
    closeDesktopGallery();
  };

  // Mobile: zoom-in button (additionally to the standard "double tap" and "pinch")
  mobileZoomInButton.addEventListener('click', () => {
    swiper.zoom.in();
  });

  // Mobile: Handle zoom-in-out button appearance
  swiper.on('zoomChange', (event, scale) => {
    if (window.innerWidth >= 992) return;
    if (scale > 1) {
      mobileZoomInButton.style = 'display: none !important;';
      closeButton.style = 'display: block !important;';
    } else {
      mobileZoomInButton.style = 'display: block !important;';
      closeButton.style = 'display: none !important;';
    }
  });
}

window.initProductVideos = function() {
  const $videos = $('[data-video-id]');
  if (!$videos.length) {
    return;
  }
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  window.onYouTubeIframeAPIReady = function() {
    $videos.each(/* @this HTMLElement */ function() {
      const $el = $(this);
      const videoId = $el.data('video-id');
      /* global YT */
      const player = new YT.Player(this, {
        videoId,
        host: 'http://www.youtube-nocookie.com',
        playerVars: {
          controls: 0,
          loop: 1,
          // playlist: videoId,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
        },
        events: {
          onReady() {
            player.mute();
          },
        },
      });
    });
  };
};

$(document).ready(() => {
  initProductGallery();
});
